import { Box } from "@mui/material"; 
import React, { useRef } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/garanties/HeroSection";
import EquipementSection from "../components/garanties/EquipementSection";
import InfoSection from "../components/garanties/InfoSection";
import AvantageSection from "../components/garanties/AvantageSection";
import AssuranceSelectionCarousel from "../components/garanties/AssuranceSelectionCarousel";
import Footer from "../components/Footer";

const Home = () => {
  const assuranceRef = useRef(null);

  const scrollToAssurance = () => {
    const offset = -60; // ajuste selon la hauteur de ta navbar
    const elementPosition = assuranceRef.current?.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition + offset,
      behavior: "smooth"
    });
  };
  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
      <HeroSection onScrollClick={scrollToAssurance} />
      <EquipementSection />
      <InfoSection />
      <AssuranceSelectionCarousel ref={assuranceRef} />
      <AvantageSection />
      <Footer />
    </>
  );
};

export default Home;